import styled from 'styled-components';
import { media } from 'utils/detection';

export default styled.ul`
  padding: 0;

  ${media.medium`
    max-width: 70%;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
 `}
`;
